import React, { useState, useEffect } from 'react';
import { Edit, Save, X, Activity } from 'lucide-react';
import Swal from 'sweetalert2';

const AdminTradeList: React.FC = () => {
  const [trades, setTrades] = useState<any[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editForm, setEditForm] = useState<any>({});

  const fetchTrades = () => {
    // fetch('http://localhost:10001/api/admin/all-trades')
    fetch('https://motilalalgo.com/api/admin/all-trades')
      .then(res => res.json())
      .then(data => {
        if (data.success) setTrades(data.trades);
      });
  };

  useEffect(() => { fetchTrades(); }, []);

  const handleEditClick = (trade: any) => {
    setEditingId(trade.id);
    setEditForm(trade);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleSave = async (id: number) => {
    try {
      // const res = await fetch(`http://localhost:10001/api/admin/edit-trade/${id}`, {
      const res = await fetch(`https://motilalalgo.com/api/admin/edit-trade/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editForm)
      });
      const data = await res.json();
      if (data.success) {
        Swal.fire('Updated!', 'Trade & Wallet Balance updated.', 'success');
        setEditingId(null);
        fetchTrades(); // Refresh list
      } else {
        Swal.fire('Error', data.error, 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Update failed', 'error');
    }
  };

  return (
    <div className="max-w-7xl mx-auto space-y-6 pb-10">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex justify-between">
        <div>
          <h1 className="text-2xl font-black text-slate-800">All User Trades</h1>
          <p className="text-sm text-slate-500 mt-1">Manage and edit trades. Wallet balances adjust automatically.</p>
        </div>
        <Activity size={36} className="text-[#3b36a4]" />
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto w-full custom-scrollbar">
          <table className="w-full text-left border-collapse min-w-[1300px]">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100 text-xs uppercase text-slate-500 font-bold">
                <th className="p-4">User</th>
                <th className="p-4">Serial No.</th> {/* NAYA COLUMN ADD KIYA YAHAN */}
                <th className="p-4">Stock</th>
                <th className="p-4">Buy Price</th>
                <th className="p-4">Buy Qty</th>
                <th className="p-4">Sell Price</th>
                <th className="p-4">Sell Qty</th>
                <th className="p-4">Profit/Loss</th>
                <th className="p-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {trades.map((trade) => (
                <tr key={trade.id} className="hover:bg-slate-50">
                  <td className="p-4 text-sm font-bold">{trade.first_name} {trade.last_name} <br/><span className="text-xs text-slate-400">{trade.login_id}</span></td>
                  
                  {editingId === trade.id ? (
                    <>
                      {/* EDIT MODE MEIN SERIAL NO INPUT */}
                      <td className="p-2"><input type="text" name="serial_no" value={editForm.serial_no || ''} onChange={handleChange} className="w-28 border p-2 rounded text-sm" placeholder="STK..." /></td>
                      <td className="p-2"><input type="text" name="stock_name" value={editForm.stock_name || ''} onChange={handleChange} className="w-24 border p-2 rounded text-sm" /></td>
                      <td className="p-2"><input type="number" name="buy_price" value={editForm.buy_price || ''} onChange={handleChange} className="w-24 border p-2 rounded text-sm" /></td>
                      <td className="p-2"><input type="number" name="buy_qty" value={editForm.buy_qty || ''} onChange={handleChange} className="w-20 border p-2 rounded text-sm" /></td>
                      <td className="p-2"><input type="number" name="sell_price" value={editForm.sell_price || ''} onChange={handleChange} className="w-24 border p-2 rounded text-sm" /></td>
                      <td className="p-2"><input type="number" name="sell_qty" value={editForm.sell_qty || ''} onChange={handleChange} className="w-20 border p-2 rounded text-sm" /></td>
                      <td className="p-2"><input type="number" name="profit_loss" value={editForm.profit_loss || ''} onChange={handleChange} className="w-24 border p-2 rounded text-sm" /></td>
                      <td className="p-4 flex gap-2 justify-center">
                        <button onClick={() => handleSave(trade.id)} className="p-2 bg-green-100 text-green-700 rounded hover:bg-green-200"><Save size={16} /></button>
                        <button onClick={() => setEditingId(null)} className="p-2 bg-red-100 text-red-700 rounded hover:bg-red-200"><X size={16} /></button>
                      </td>
                    </>
                  ) : (
                    <>
                      {/* NORMAL VIEW MEIN SERIAL NO */}
                      <td className="p-4 text-sm text-slate-600 font-medium">{trade.serial_no || '-'}</td>
                      <td className="p-4 text-sm font-bold text-slate-700">{trade.stock_name}</td>
                      <td className="p-4 text-sm">₹{trade.buy_price}</td>
                      <td className="p-4 text-sm">{trade.buy_qty}</td>
                      <td className="p-4 text-sm">₹{trade.sell_price}</td>
                      <td className="p-4 text-sm">{trade.sell_qty}</td>
                      <td className={`p-4 text-sm font-bold ${parseFloat(trade.profit_loss) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                         {parseFloat(trade.profit_loss) > 0 ? '+' : ''}₹{trade.profit_loss}
                      </td>
                      <td className="p-4 text-center">
                        <button onClick={() => handleEditClick(trade)} className="text-blue-600 hover:text-blue-800 bg-blue-50 p-2 rounded"><Edit size={16} /></button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {trades.length === 0 && (
                <tr><td colSpan={9} className="text-center p-6 text-slate-500">No trades found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default AdminTradeList;